import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { AboutUsCover } from "./AboutUsCover";
import { CTASection } from "../../CallToAction";
import { DescriptionSection, DescriptionSectionParagraph } from "./DescriptionSection";
import { WhoWeAreSection } from "./WhoWeAreSection";
import { JoinGroupBanner } from "./JoinGroupBanner";
import { OurPartnersSection } from "../../Partners";
import { InsidePageWrapper, OutsidePageWrapper, SimpleImage } from "@parkschannel/ui";
import { useButtonsAnalytics } from "../../../utils";
export const AboutUsPage = ()=>{
    useButtonsAnalytics();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(OutsidePageWrapper, {
                children: /*#__PURE__*/ _jsx(AboutUsCover, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ _jsx(OutsidePageWrapper, {
                        className: "!py-[48px] lg:!py-[80px]",
                        children: /*#__PURE__*/ _jsx(InsidePageWrapper, {
                            children: /*#__PURE__*/ _jsxs(DescriptionSection, {
                                title: "Our mission",
                                icon: /*#__PURE__*/ _jsx("div", {
                                    className: "relative w-[50px] h-[50px]",
                                    children: /*#__PURE__*/ _jsx(SimpleImage, {
                                        src: "/media/illustrations/tv-parks-channel.webp",
                                        alt: "Grand canyon",
                                        fill: true,
                                        className: "object-contain"
                                    })
                                }),
                                bgcImg: "/media/obamabridge.webp",
                                children: [
                                    /*#__PURE__*/ _jsx(DescriptionSectionParagraph, {
                                        className: "md:mb-4 lg:mb-2",
                                        children: "We all long to connect to something bigger than ourselves. Parks give us that. Natural spaces broaden our horizons and remind us of our place in the universe. Historic spaces bond us to our shared heritage and deepen our understanding of where we’ve come from."
                                    }),
                                    /*#__PURE__*/ _jsx(DescriptionSectionParagraph, {
                                        children: "At Parks Channel, our mission is to become a destination platform for “America’s Best Idea” – at home, on the journey and for making memories. We want to make it easier to discover amazing places and then actually go there. We want to tell stories that entertain and inform. We want to build a community of content creators who inspire others through their journeys."
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(OutsidePageWrapper, {
                        className: "!py-[48px] lg:!py-[80px]",
                        children: /*#__PURE__*/ _jsx(InsidePageWrapper, {
                            children: /*#__PURE__*/ _jsxs(DescriptionSection, {
                                title: "One more, very important thing",
                                icon: /*#__PURE__*/ _jsx("div", {
                                    className: "relative w-[50px] h-[50px]",
                                    children: /*#__PURE__*/ _jsx(SimpleImage, {
                                        src: "/media/illustrations/earth.webp",
                                        alt: "Grand canyon",
                                        fill: true,
                                        className: "object-contain"
                                    })
                                }),
                                bgcImg: "/media/grand-canyon.jpg",
                                reverse: true,
                                children: [
                                    /*#__PURE__*/ _jsx(DescriptionSectionParagraph, {
                                        children: "The Parks Channel is deeply committed to the mission of protecting and enhancing the park experience."
                                    }),
                                    /*#__PURE__*/ _jsx(DescriptionSectionParagraph, {
                                        children: "Our content will cover critical issues facing our parks, including efforts to reach younger and more diverse demographics, mitigate the challenges of climate change and address the problem of overcrowding, as well as campaigns to protect more of our natural and historic spaces."
                                    }),
                                    /*#__PURE__*/ _jsx(DescriptionSectionParagraph, {
                                        children: "The Parks Channel will set aside a portion of profits to support science, conservation and heritage projects, working with non-profit groups to help achieve their goals."
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(OutsidePageWrapper, {
                className: "!py-[56px] lg:!py-[96px]",
                children: /*#__PURE__*/ _jsx(InsidePageWrapper, {
                    children: /*#__PURE__*/ _jsx(WhoWeAreSection, {})
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "bg-white",
                children: /*#__PURE__*/ _jsx(CTASection, {})
            }),
            /*#__PURE__*/ _jsx(OurPartnersSection, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "bg-white mb-2 md:mb-4 lg:mb-[102px]",
                children: /*#__PURE__*/ _jsx(OutsidePageWrapper, {
                    className: "!py-[80px] lg:!py-[88px]",
                    children: /*#__PURE__*/ _jsx(InsidePageWrapper, {
                        children: /*#__PURE__*/ _jsx(JoinGroupBanner, {})
                    })
                })
            })
        ]
    });
};
